
  import {defineComponent} from 'vue';
  import paycoUtils from "@/assets/js/utils";
  import ToTopComponent from "@/components/shared/TopButtonComponent.vue";
  import RecentSearchWordComponent from "@/components/search/RecentSearchWordComponent.vue";
  import Product from "@/domain/product/Product";
  import api from "@/api/backend-api";
  import {mapGetters} from "vuex";
  import DeleteRecentSearchWordRequest from "@/domain/request/DeleteRecentSearchWordRequest";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import router from "@/router";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import store from "@/store";

  export default defineComponent({
    name: 'SearchView',
    components: {
      HeaderComponent,
      RecentSearchWordComponent,
      ToTopComponent
    },
    data() {
      return {
        recentSearchWordList: [] as Array<string>,
        searchWord: '',
        isTypingMode: false,

        page: 1,
        perPage: 20,
        hasMorePage: true as boolean,

        isLoading: false as boolean,
        debouncedScrollEvent: () => {
          return
        },

        totalCount: 0 as number,
        products: [] as Array<Product>
      }
    },
    created() {
      if (this.hasLogined) {
        this.getRecentSearchWordList();
      }
    },
    methods: {
      focusSearchInputArea(): void {
        (this.$refs.searchInputArea as HTMLElement).focus();
      },
      setSearchWord(searchWord: string): void {
        this.searchWord = paycoUtils.removeCharacterExceptKorEngNum(searchWord);
      },
      inputSearchWord(event: Event): void {
        const searchWord = (event.currentTarget as HTMLInputElement).value;
        this.setSearchWord(searchWord);
      },
      moveToPreviousPage(): void {
        router.back();
      },
      clickRecentSearchWord(recentSearchWord: string): void {
        this.setSearchWord(recentSearchWord);
        this.moveToSearchResultPage();
      },
      deleteRecentSearchWord(deleteAllYn: string, keyword: string): void {
        const request = new DeleteRecentSearchWordRequest(deleteAllYn, keyword);
        api.deleteRecentSearchWord(request)
        .then(response => {
          // console.log(response);
          this.getRecentSearchWordList();
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      setTypingMode(typingMode: boolean): void {
        this.isTypingMode = typingMode;
      },
      eraseSearchWord(): void {
        this.searchWord = '';
        this.focusSearchInputArea();
      },
      setPageDefaultStatus(): void {
        this.searchWord = '';
        (this.$refs.searchInputArea as HTMLElement).blur();
      },
      getRecentSearchWordList(): void {
        api.getRecentSearchWord()
        .then(response => {
          console.log(response);
          // token 및 phoneNumber가 정상적이지 않아 최근검색어 데이터를 못가져오는 경우
          if (response.data.result === null) {
            store.commit('MemberStore/removeMemberAuthData');
            if (store.getters['AppYnStore/isApp']) {
              router.push(new NamedRouting('NonMemberViewForApp', {channelId: store.state.ChannelStore.channelId}));
            } else {
              store.commit('NextViewStore/setNextView', new NamedRouting('SearchView'));
              router.push(new NamedRouting('NonMemberView', store.state.ChannelStore.channelId));
            }
            return;
          }
          this.recentSearchWordList = response.data.result.map(recentSearchWord => recentSearchWord);
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      },
      moveToSearchResultPage(): void {
        router.push(new NamedRouting('SearchResultView', {}, {query: this.searchWord, sort: "POPULARITY"}));
      },
    },
    computed: {
      hasRecentSearchWordList(): boolean {
        return this.recentSearchWordList.length > 0;
      },
      hasSearchWord(): boolean {
        return this.searchWord.length > 0;
      },
      hasSearchResult(): boolean {
        return this.products.length > 0;
      },
      ...mapGetters('SortOptionStore', [
        'getSortOptionValue'
      ]),
      ...mapGetters('MemberStore', [
        'hasLogined'
      ]),
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
  });


